
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ReservationItemModule } from '@/store/modules/reservationItem';

@Component({
  name: 'ServiceTermsForm',
  components: {
  },
})
export default class extends Vue {
  get serviceTermsList() {
    return ReservationItemModule.form.serviceTermsList;
  }
}
